import SpcError from './SpcError';

export default class RequestCancelledError extends SpcError {
  public static code = 'SPC-REQUEST-CANCELED';

  constructor(message: string) {
    super(message);

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, RequestCancelledError.prototype);
    this.name = this.getCode();
  }
}
